/* eslint-disable max-len */

import { fabric } from 'fabric';
import { FABRIC_CUSTOM_OBJECT } from '../../../utils';

export function createControlRectTextSVG(e) {
  const { target } = e;
  const { left, top, width, height } = target;
  const { canvas } = window;
  const myText = JSON.parse(JSON.stringify(target.textStyle));
  const myPath = JSON.parse(JSON.stringify(target.pathStyle));
  const pointer = window.canvas.getPointer(e);
  const controlSearchIcon =
    Math.abs(pointer.x - (target.left + myPath.deltaX)) * 2 <= myPath.width * myPath.scaleX &&
    Math.abs(pointer.y - (target.top + myPath.deltaY)) * 2 <= myPath.height * myPath.scaleY;
  if (controlSearchIcon) {
    const searchIcon = new fabric.Path(myPath.path, {
      ...myPath,
      padding: myPath.padding || 10,
      name: FABRIC_CUSTOM_OBJECT.iconRectTextSVG,
      isNotObj: true,
      parentObj: target,
      borderColor: 'blue',
      objectCaching: false,
      left: target.left + myPath.deltaX + target.strokeWidth / 2,
      top: target.top + myPath.deltaY + target.strokeWidth / 2,
      originX: 'center',
      originY: 'center',
    });
    target.pathStyle = { ...target.pathStyle, opacity: 0 };
    target.clipPath = null;

    canvas.remove(target);
    canvas.add(target);
    canvas.add(searchIcon);
    canvas.setActiveObject(searchIcon);
  } else {
    const textBox = new fabric.Textbox(myText.text, {
      ...myText,
      name: FABRIC_CUSTOM_OBJECT.textRectTextSVG,
      lockMovementX: true,
      lockMovementY: true,
      hasControls: false,
      isNotObj: true,
      parentObj: target,
      borderColor: 'blue',
      objectCaching: false,
      borderScaleFactor: 2,
      left: left + width / 2 + myText.left + target.strokeWidth / 2,
      top: top + height / 2 + myText.top + target.strokeWidth / 2,
    });
    target.set({ clipPath: null, textStyle: { ...target.textStyle, text: '' } });

    canvas.add(textBox);
    canvas.setActiveObject(textBox);
    textBox.enterEditing();
    textBox.hiddenTextarea.focus();
    textBox.selectAll();
  }

  return true;
}

export function controlRectTextSVGModified(e) {
  const target = e;
  if (target.parentObj.textStyle.textAlign !== target.textAlign) {
    target.parentObj.set({
      textStyle: {
        ...target.parentObj.textStyle,
        textAlign: target.textAlign,
      },
    });
    target.parentObj.updateTextStyle();
    const myRect = target.parentObj;
    target.set({
      left: myRect.left + myRect.width / 2 + myRect.textStyle.left + myRect.strokeWidth / 2,
      top: myRect.top + myRect.height / 2 + myRect.textStyle.top + myRect.strokeWidth / 2,
      originX: myRect.textStyle.originX,
      originY: myRect.textStyle.originY,
      textAlign: myRect.textStyle.textAlign,
    });
    const { canvas } = window;
    target.setCoords();
    canvas.remove(target);
    canvas.add(target);
    canvas.setActiveObject(target);
  }
  return true;
}
export function controlRectTextSVGMoving(e) {
  const { target } = e;
  const myRectTextSVG = target.parentObj;
  const width = target.width * target.scaleX;
  const height = target.height * target.scaleY;

  if (target.left - width / 2 < myRectTextSVG.left) target.set({ left: myRectTextSVG.left + width / 2 });
  if (target.left + width / 2 > myRectTextSVG.left + myRectTextSVG.width)
    target.set({ left: myRectTextSVG.left + myRectTextSVG.width - width / 2 });
  if (target.top - height / 2 < myRectTextSVG.top) target.set({ top: myRectTextSVG.top + height / 2 });
  if (target.top + height / 2 > myRectTextSVG.top + myRectTextSVG.height)
    target.set({ top: myRectTextSVG.top + myRectTextSVG.height - height / 2 });

  return true;
}
export function controlRectTextSVGRemove(target) {
  const { canvas } = window;
  const parentObj = canvas.getObjects().find((o) => o.id === target.parentObj.id);

  const options = JSON.parse(JSON.stringify(target));
  if (target.name === FABRIC_CUSTOM_OBJECT.textRectTextSVG) {
    parentObj.set({ textStyle: { ...options }, clipPath: null });
  } else {
    parentObj.set({
      pathStyle: {
        ...options,
        padding: 10,
        deltaX: options.left - parentObj.left - parentObj.strokeWidth / 2,
        deltaY: options.top - parentObj.top - parentObj.strokeWidth / 2,
      },
      clipPath: null,
    });
  }
  canvas.remove(target);
  return true;
}
